import { render, staticRenderFns } from "./v-right-card1.vue?vue&type=template&id=9ffbca8a&scoped=true"
import script from "./v-right-card1.vue?vue&type=script&lang=js"
export * from "./v-right-card1.vue?vue&type=script&lang=js"
import style0 from "./v-right-card1.vue?vue&type=style&index=0&id=9ffbca8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffbca8a",
  null
  
)

export default component.exports